import { Injectable } from '@angular/core';
import { EssentialObject, EssentialObjectService } from '@ex/module/core/services/essential-object.service';
import { ZenCDKService } from '@ex/module/shared/Theme/services/zen-cdk.service';
import { AirLaunchAnnouncementComponent } from '../../ui/air-launch-announcement/air-launch-announcement.component';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { Database, get, ref, update } from '@angular/fire/database';
import { from, Observable, of } from 'rxjs';
import { ANNOUNCEMENT_CONFIG, AnnouncementConfig } from '../models/announcement-config';
import { AnnouncementRouteGateService } from './announcement-route-gate.service';
import { CultureLaunchAnnouncementsComponent } from '../../ui/culture-launch-announcements/culture-launch-announcements.component';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {
  private readonly AnnouncementKey = 'Announcements';
  private initialised = false;
  private announcements?: HTMLElement;
  private announcementsRenewal?: ReturnType<typeof setInterval>;
  constructor(private essentialObject: EssentialObjectService, private zenCdk: ZenCDKService, private db: Database, private routeGate: AnnouncementRouteGateService, private http: HttpClient) { }

  // Called explicitly from the header. Deliberately not constructor work: the previous
  // version hid this in a constructor, so commenting out one injection silently
  // disabled announcements for everyone with no error and no failing test.
  init(): void {
    if (this.initialised) return;
    this.initialised = true;

    this.essentialObject.essentialObject.pipe(
      filter(x => x.user != null),
      take(1),
      switchMap((essentialObject: EssentialObject) =>
        this.getConfig().pipe(map(config => ({ config, essentialObject })))
      ), tap(x=> {

      // new announcements
      // this.mountAnnouncements(x.essentialObject);
      }),
      filter(({ config }) => config?.enabled === true && !!config.activeKey),
      switchMap(({ config, essentialObject }) =>
        this.get(essentialObject.tenant.key, essentialObject.user.key, config.activeKey).pipe(
          map(seen => ({ seen, config, essentialObject }))
        )
      ),
      filter(({ seen }) => !seen),
      // After the seen-check on purpose: one Firebase read per session, then wait.
      switchMap(({ config, essentialObject }) =>
        this.routeGate.firstAllowed$(config.allowedRoutes).pipe(map(() => ({ config, essentialObject })))
      )
    ).subscribe(({ config, essentialObject }) => {
      this.openAnnouncement(config, essentialObject)

    });
  }

  // Marked seen on dismiss rather than on open, so closing the tab early does not
  // burn the user's single impression.
  private openAnnouncement(config: AnnouncementConfig, essentialObject: EssentialObject) {
    this.zenCdk.openComponent(CultureLaunchAnnouncementsComponent, { essentialObject })
      .pipe(take(1))
      .subscribe(() =>
        this.update(essentialObject.tenant.key, essentialObject.user.key, config.activeKey, {
          show: true,
          seenAt: Date.now()
        })
      );
  }

  // Config is a build-time constant, not remote state — it only changes on a deploy.
  // Kept as a seam so tests can drive the disabled and missing-config paths.
  getConfig(): Observable<AnnouncementConfig> {
    return of(ANNOUNCEMENT_CONFIG);
  }

  get(tenantKey: string, userKey: string, announcementKey: string): Observable<any> {
    return from(get(ref(this.db, `/${this.AnnouncementKey}/${tenantKey}/${userKey}/${announcementKey}`))).pipe(
      map(snapshot => snapshot.val())
    );
  }

  update(tenantKey: string, userKey: string, announcementKey: string, val: any) {
    return update(ref(this.db, `/${this.AnnouncementKey}/${tenantKey}/${userKey}/${announcementKey}`), val);
  }




  // new announcements 

  private mountAnnouncements(obj:EssentialObject): void {
    if (this.announcements) {
      return;
    }

    const element = document.createElement('zen-announcements');
    document.body.appendChild(element);
    this.announcements = element;

    this.refreshAnnouncementToken(obj);

    // Renewed before the 30-minute session runs out, so a tab left open all day keeps its
    // channel. One request every 25 minutes.
    this.announcementsRenewal = setInterval(() => this.refreshAnnouncementToken(obj), 25 * 60 * 1000);
  }

  private refreshAnnouncementToken(obj:EssentialObject): void {
    if (!this.announcements) {
      return;
    }

    const segments = [obj.user.key, obj.user.firstName + " " + obj.user.lastName, obj.user.email, obj.selectedEntity.nativeName].map(encodeURIComponent).join('/');

    this.http.get<{ token?: string }>(`${environment.coreApi}announcement-token/${segments}`).subscribe({
      // 204 (nobody signed in, or announcements not configured here) arrives as a null body.
      next: response => {
        if (response?.token) {
          this.announcements?.setAttribute('token', response.token);
        }
      },
      // Announcements are decoration. If this fails, the product carries on without them.
      error: () => undefined,
    });
  }



}
